import { useState } from "react";
import PropTypes from "prop-types";
import { X, LoaderCircle } from "lucide-react";
import SnackbarUtils from "../../../lib/components/Snackbar/utils";

const ResetModal = ({ isOpen, onClose, onSubmit }) => {
  const [resetType, setResetType] = useState("Soft");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Reset</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="reset-options">
            <label className="reset-option">
              <input
                type="radio"
                value="Soft"
                checked={resetType === "Soft"}
                onChange={e => setResetType(e.target.value)}
              />
              <span>Soft reset</span>
            </label>
            <p style={{ fontSize: 12, color: "#64748b", margin: "2px 0 6px 12px", lineHeight: 1.4 }}>
              Restarts the charger after completing ongoing sessions.
            </p>
            <label className="reset-option">
              <input
                type="radio"
                value="Hard"
                checked={resetType === "Hard"}
                onChange={e => setResetType(e.target.value)}
              />
              <span>Hard reset</span>
            </label>
            <p style={{ fontSize: 12, color: "#64748b", margin: "2px 0 0 12px", lineHeight: 1.4 }}>
              Immediately restarts the charger, stopping any ongoing charging sessions.
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-submit"
            disabled={isSubmitting}
            onClick={async () => {
              setIsSubmitting(true);
              try {
                await onSubmit(resetType);
                SnackbarUtils.success("Command sent");
                onClose();
              } catch (e) {
                const msg =
                  e?.response?.data?.["error-message"] || e?.response?.data?.message || e?.message || JSON.stringify(e);
                SnackbarUtils.error(msg);
              } finally {
                setIsSubmitting(false);
              }
            }}
          >
            {isSubmitting ? <LoaderCircle className="animate-spin" size={16} /> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

ResetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ResetModal;
